import { c as _c } from "react/compiler-runtime";
import { Stack, Typography, type TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';
import { Icon } from '@/components/shared/icon';
export const EmptyStateContent = t0 => {
  const $ = _c(28);
  const {
    title,
    description,
    icon,
    media,
    primaryAction,
    secondaryAction,
    titleVariant,
    descriptionVariant,
    gap,
    textGap,
    maxWidth
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = typeof icon === "string" ? <Icon iconClass={icon} /> : icon;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconElement = t1;
  let t2;
  if ($[2] !== primaryAction || $[3] !== secondaryAction) {
    t2 = [secondaryAction, primaryAction].filter(Boolean);
    $[2] = primaryAction;
    $[3] = secondaryAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const actions = t2;
  let t3;
  if ($[5] !== gap || $[6] !== maxWidth) {
    t3 = {
      alignItems: "center",
      gap,
      maxWidth,
      textAlign: "center"
    };
    $[5] = gap;
    $[6] = maxWidth;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== textGap) {
    t4 = {
      alignItems: "center",
      gap: textGap
    };
    $[8] = textGap;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== title || $[11] !== titleVariant) {
    t5 = title && <Typography variant={titleVariant} align="center">{title}</Typography>;
    $[10] = title;
    $[11] = titleVariant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== description || $[14] !== descriptionVariant) {
    t6 = description && <Typography variant={descriptionVariant} align="center">{description}</Typography>;
    $[13] = description;
    $[14] = descriptionVariant;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <Stack sx={t4}>{t5}{t6}</Stack>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== actions) {
    t8 = actions.length > 0 && <Stack direction="row" sx={{
      gap: "12px",
      alignItems: "center"
    }}>{actions}</Stack>;
    $[20] = actions;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== iconElement || $[23] !== media || $[24] !== t3 || $[25] !== t7 || $[26] !== t8) {
    t9 = <Stack sx={t3}>{media}{iconElement}{t7}{t8}</Stack>;
    $[22] = iconElement;
    $[23] = media;
    $[24] = t3;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};